import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import OrderBundleOptionValue from "./OrderBundleOptionValue";
const OrderBundleOption = ({ values }) => (_jsx(_Fragment, { children: values.map((option) => {
        const { initial_price, presentation_price, product } = option?.presentation_info || {};
        return (_jsx(OrderBundleOptionValue, { prices: { initial_price, presentation_price }, quantity: option.quantity, imageUrl: product?.small_image?.url, product_name: option.product_name }, option.product_name));
    }) }));
export default OrderBundleOption;
//# sourceMappingURL=OrderBundleOption.js.map